import company from '@/api/modules/companyApi.ts';
import auth from '@/api/modules/authApi.ts';
import accountAdmin from '@/api/modules/accountAdmin.ts';
import relationshipTypes from '@/api/modules/relationshipTypes.ts';
import systemAdmin from '@/api/modules/systemAdminApi.ts';
import alerts from '@/api/modules/alertsApi.ts';
import account from '@/api/modules/account.ts';
import webappConfig from '@/api/modules/webappConfig.ts';
import workflow from '@/api/modules/workflow.ts';
import monitoring from '@/api/modules/monitoringApi.ts';
import systemAdminMonitoring from '@/api/modules/systemAdminMonitoringApi.ts';
import entityPulse from '@/api/modules/entityPulseApi.ts';
import screeningInternational from '@/api/modules/screeningInternationalApi.ts';
import sarCases from '@/api/modules/sarCasesApi.ts';
import parecer from '@/api/modules/parecerApi.ts';

export default {
  company,
  auth,
  accountAdmin,
  relationshipTypes,
  systemAdmin,
  alerts,
  account,
  webappConfig,
  workflow,
  monitoring,
  systemAdminMonitoring,
  entityPulse,
  screeningInternational,
  sarCases,
  parecer
};
